<template>

    <router-view/>
    
    </template>
    
    <style>
    html {
      scroll-behavior: smooth;
    }

    body {
      margin: 0;
      background-color: var(--ms-ink);
      color: var(--ms-text);
    }

    #app {
      font-family: var(--font-body);
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      min-height: 100vh;
      color: var(--ms-text);
      background-color: var(--ms-ink);
    }
    </style>
    